import { render } from "./BookBookingResult.vue?vue&type=template&id=1952847a"
import script from "./BookBookingResult.vue?vue&type=script&lang=js"
export * from "./BookBookingResult.vue?vue&type=script&lang=js"
script.render = render

export default script